export const updateEducationFormFields = {
  institutionName: '',
  logo: '',
  degreeName: '',
  field: '',
  start: '',
  end: '',
  currentlyStudying: false
};

export const updateEducationErrors = {
  institutionName: '',
  logo: '',
  degreeName: '',
  field: '',
  start: '',
  end: '',
  currentlyStudying: ''
};
